import React from 'react';
import SearchBar from '../../../../../../../../../../../../../../components/search-bar/index';
import {connect} from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
	enteredCollaboratorSearchValue,
	findCollaborators,
} from '../../../../../../../../../../../../../../../actions/sharingDetailsActions';
import {upperCaseFirstLetter} from '../../../../../../../../../../../../../../utils/index';
import {findDomainGroup} from '../../../../../../../../../../../../../../../actions/domainGroupActions';

class SearchCollaborator extends React.Component {

	constructor(props){
		super(props);

		this.changeHandler = this.changeHandler.bind(this);
	}

	changeHandler(e){

		if(this.props.selectedCollaborator !== null){

			this.props.enteredCollaboratorSearchValue(e.target.value);

			if(e.target.value.length > 0){
				this.props.setFindDomainGroup(this.props.selectedCollaborator.id)
			} else {
				this.props.setFindDomainGroup(this.props.selectedCollaborator.id, this.props.domainGroupPageSize)
			}

		} else {
            this.props.enteredCollaboratorSearchValue(e.target.value);
		}

	}

	render() {
		return (
			<SearchBar
				id="searchCollaborator"
				label="Search a collaborator"
				title={this.props.t("popupSharingSearchCollaborators")}
				srOnly={true}
				onChange={this.changeHandler}
				placeholder={upperCaseFirstLetter(this.props.t("popupSharingSearchCollaborators"))}
				width={190}
			/>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
		findCollaborators: state.sharingDetailsReducer.findCollaborators,
        selectedCollaborator: state.sharingDetailsReducer.selectedCollaborator,
		collaboratorsPageSize: state.sharingDetailsReducer.collaboratorsPageSize,
		findDomainGroup: state.domainGroupReducer.findDomainGroup,
		domainGroupPageSize: state.domainGroupReducer.domainGroupPageSize
    };
};

const mapDispatchToProps = (dispatch) => {
	return {
		setFindCollaborators : (labelId, pageSize) => {
			dispatch(findCollaborators(labelId, pageSize))
		},
		enteredCollaboratorSearchValue  : (string) => {
			dispatch(enteredCollaboratorSearchValue(string))
		},
		setFindDomainGroup : (collaboratorId, pageSize) => {
            dispatch(findDomainGroup(collaboratorId, pageSize))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SearchCollaborator));
